import { render, staticRenderFns } from "./callbackConf.vue?vue&type=template&id=814d0856&scoped=true&"
import script from "./callbackConf.vue?vue&type=script&lang=js&"
export * from "./callbackConf.vue?vue&type=script&lang=js&"
import style0 from "./callbackConf.vue?vue&type=style&index=0&id=814d0856&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814d0856",
  null
  
)

export default component.exports